const components = [
  {
    title: "自由布局",
    tag: "de-layout-free",
    type: "layout",
    slotPanel: "de-layout-free-slot-panel",
    group: "layout",
    props: [
      {
        title: "背景颜色",
        name: "color",
        type: {
          name: "color"
        },
        default: "#00000000"
      },
      {
        title: "背景图片",
        name: "image",
        type: {
          name: "image"
        },
        default: ""
      },
      {
        title: "背景图宽",
        name: "width",
        type: {
          name: "number-unit",
          options: {
            units: [
              {
                value: "px",
                label: "像素"
              },
              {
                value: "%",
                label: "百分比"
              }
            ]
          }
        },
        default: {
          value: 100,
          unit: "%"
        }
      },
      {
        title: "背景图高",
        name: "height",
        type: {
          name: "number-unit",
          options: {
            units: [
              {
                value: "px",
                label: "像素"
              },
              {
                value: "%",
                label: "百分比"
              }
            ]
          }
        },
        default: {
          value: 100,
          unit: "%"
        }
      },
      {
        title: "背景重复",
        name: "repeat",
        type: {
          name: "select1",
          options: {
            options: [
              {
                value: "no-repeat",
                label: "不重复"
              },
              {
                value: "repeat",
                label: "XY轴都重复"
              },
              {
                value: "repeat-x",
                label: "X轴重复"
              },
              {
                value: "repeat-y	",
                label: "Y轴重复"
              }
            ]
          }
        }
      }
    ],
    slots: [],
    events: [],
    actions: []
  },
  {
    title: "请选择边框",
    tag: "de-border",
    type: "border",
    group: "layout",
    propEditor: "de-border-default-panel",
    props: [
      {
        title: "显示标题",
        name: "showTitle",
        type: { name: "bool" }
      },
      {
        title: "标题字体",
        name: "titleFont",
        type: { name: "font" }
      }
    ]
  },
  {
    title: "雄安边框组件",
    tag: "de-border-wrapper",
    type: "border",
    group: "layout",
    props: []
  },
  {
    title: "角线条边框",
    tag: "de-corner-border",
    type: "border",
    group: "layout",
    props: []
  },
  {
    title: "tab",
    tag: "de-tab-cop",
    type: "layout",
    group: "layout",
    resizeMethod:'resize',
    events: [
      {
        name: "tab-changed",
        title: "tab发生变化"
      }
    ],
    eventHandlers: [
      {
        name: "change",
        title: "激活tab"
      }
    ],
    props: [
      {
        title: "标签项",
        name: "labels",
        type: { name: "text" },
        default: "标签一,标签二,标签三"
      },
      {
        title: "tab激活项",
        name: "activedIndex",
        type: {
          name: "number"
        },
        default: 0
      },
      {
        title: "定时切换",
        name: "loop",
        type: {
          name: "number"
        },
        default: 0
      },
      {
        title: "编辑头部",
        name: "editHeader",
        description: "打开后，拖拽组件作为头部",
        type: {
          name: "bool"
        },
        default: false
      },
      {
        title: "头部高度",
        name: "headerHeight",
        type: {
          name: "number"
        },
        default: 50
      },
      {
        title: "头部字体",
        name: "titleFontObj",
        type: {
          name: "font"
        },
        default: {
          fontSize: 12,
          fontStyle: "normal",
          color: "#fff",
          fontFamily: "PingFang",
          fontWeight: "normal"
        }
      }
    ]
  },

  {
    title: "滚动布局",
    tag: "de-layout-overflow",
    type: "layout",
    group: "layout",
    slotPanel: "de-layout-column-slot-panel",
  },
  {
    title: "纵向布局",
    tag: "de-layout-column",
    type: "layout",
    group: "layout",
    slotPanel: "de-layout-column-slot-panel",
  },
  {
    title: "横向布局",
    tag: "de-layout-row",
    type: "layout",
    group: "layout",
    slotPanel: "de-layout-row-slot-panel",
  }
];
export default components;
